/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../api/deprecated/CanvasAPI',
	'../lib/@waca/core-client/js/core-client/utils/Deferred',
	'../dashboard/api/FilterAPI',
	'underscore'
], (APIFactory, DeprecatedCanvasAPI, Deferred, DeprecatedFilterApi, _) => {
	class CanvasAPIImpl {
		constructor(dashboardAPI, boardModel, canvasController, layoutController, widgetLoader) {

			this.widgetLoader = widgetLoader;
			this.boardModel = boardModel;
			this.canvasController = canvasController;
			this.layoutController = layoutController;
			this.dashboardAPI = dashboardAPI;

			// TODO: remove this -- it is just here because some code might be using it
			this.controller = this.canvasController;

			this.filterApi = new DeprecatedFilterApi(this.canvasController, this.dashboardAPI);
		}

		getAPI() {
			if (!this.api) {
				this.api = APIFactory.createAPI(this, [DeprecatedCanvasAPI], {
					deprecatedPropList: ['controller']
				});
			}
			return this.api;
		}

		getWidgetsWhenRendered() {
			return this.dashboardAPI.waitTillWidgetsRendered.apply(this.dashboardAPI, arguments);
		}

		deselectAllWidgets() {
			return this.dashboardAPI.deselectAllWidgets.apply(this.dashboardAPI, arguments);
		}

		destroy() {

			this.widgetLoader = null;
			this.boardModel = null;
			this.canvasController = null;
			this.layoutController = null;
			this.dashboardAPI = null;

			// TODO: remove this -- it is just here because some code might be using it
			this.controller = null;

			this.filterApi = null;

		}

		getFilters() {
			return this.filterApi;
		}

		getSelectedWidgets() {
			const widgetModels = this.layoutController.getSelectedWidgets();
			const widgets = [];
			widgetModels.forEach(model => {
				const widget = this.getWidget(model.id);
				if (widget) {
					widgets.push(widget);
				}
			});
			return widgets;
		}

		getWidgetWhenReady(id) {

			if (this.widgetLoader) {
				return this.widgetLoader.getWidgetAsync(id).then(widget => {
					if (widget) {
						return widget.getAPI();
					}
				});
			} else {
				return Promise.reject(new Error('No longer alive!'));
			}
		}

		getWidget(id) {
			if (this.widgetLoader) {
				const widget = this.widgetLoader.getWidget(id);
				if (widget) {
					return widget.getAPI();
				}
			}
		}

		getWidgets() {
			let id;
			const widgets = [];
			let widget;
			for (id in this.boardModel.widgetInstances) {
				widget = this.getWidget(id);
				if (widget) {
					widgets.push(widget);
				}
			}
			return widgets;
		}

		addFragment(options, sender, payloadData) {
			if (payloadData === undefined) payloadData = null;

			//sets preferred add options in CanvasController Class
			this.layoutController.setPreferredAddOptions(options);

			var payload = this.boardModel.addFragment(options, sender ? sender : 'api', payloadData);
			var parameter = payload && payload.value && payload.value.parameter;
			return parameter && parameter.model && parameter.model.layout && parameter.model.layout.id; //return model id of added widget

		}

		hasMaximizedWidget() {
			return this.canvasController.layoutController.hasMaximizedWidget();
		}



		removeWidget(widgetId, sender) {
			this.boardModel.removeWidget(widgetId, sender ? sender : 'api');
		}



		selectWidget(widgetId, options) {
			var deferred = new Deferred();
			this.layoutController.whenWidgetRenderComplete(widgetId).done(function (layout) {
				var selectionHandler = this.layoutController.interactionController.selectionHandler;
				if (options && !options.multiSelect) {
					selectionHandler.deselectAll();
				}
				// pass the flag isTouch to properly render the resize edges for touch device.
				selectionHandler.selectNode(layout.domNode, options);
				deferred.resolve();
			}.bind(this));
			return deferred.promise;
		}

		selectWidgets(widgetIds, options) {
			options = options || {};
			options = _.extend(options, {
				'multiSelect': true
			});
			let promises = [];
			for (let widgetId in widgetIds) {
				promises.push(this.selectWidget(widgetIds[widgetId], options));
			}
			return Promise.all(promises);
		}


		getLayout(id) {
			const layoutView = this.canvasController.layoutController.getView(id);
			if (layoutView && layoutView.view) {
				return layoutView.view.getAPI();
			}
		}

		getFeature(id) {
			return this.canvasController.getFeature(id);
		}

		registerFeature(id, feature) {
			return this.canvasController.registerFeature(id, feature);
		}
	}

	return CanvasAPIImpl;
});
